/** Faixa superior fixa. A barra vai de ponta a ponta; o conteúdo respeita a
 *  coluna de leitura de 550px, que é o que sobrou do antigo container. */
export const Toolbar = ({ children, ...rest }) => (
  <div
    id="level-play-toolbar"
    className="w-full shrink-0 grow-0 border-b border-gray-200 px-4 pb-3 pt-[calc(0.75rem+env(safe-area-inset-top))]"
    {...rest}
  >
    <div className="mx-auto flex w-full max-w-[550px] items-center justify-between gap-2">
      {children}
    </div>
  </div>
)
